module.exports = __webpack_public_path__ + "img/hyal-1.e4c3e2eb.png";